import { Footer } from "@albelli/arc-3-react/lib/Footer";
import { requestMenu } from "application/menu/menuActions";
import { isLoading, isNotRequested } from "helpers/requestStateHelper";
import { vendor } from "helpers/vendorHelper";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

export const MyAccountFooter = () => {
  const menu = useSelector(state => state.menu);
  const dispatch = useDispatch();
  useEffect(() => {
    if (isNotRequested(menu)) {
      dispatch(requestMenu());
    }
  }, []);

  const { items } = menu;
  if (isLoading(menu) || !items) return null;

  return <Footer storefrontConfig={items} vendor={vendor} />;
};
